import numeral from "numeral";

export const urls = {
  URL: process.env.REACT_APP_URL_BASE,
  URL_CP: process.env.REACT_APP_URL_CP,
  api: process.env.REACT_APP_REMOTE_URL,
}

export const tokenID = "templateID";

export const _latestObject = ({ sortArr, key }: { sortArr: any[], key: string }) => {
  return sortArr.reduce((latest, current) => {
    return current[key] > latest[key] ? current : latest;
  }, sortArr[0])[0];
}


export const _formatNumbers = (
  { n, convert = true, alt = 'free', format = '0,00.00', prefix }:
    { n: number, convert?: boolean, alt?: string | number, format?: string, prefix?: string }
) => {
  if (!n || n === 0) { return alt; }
  return (prefix ? prefix : '') + numeral(convert ? n / 100 : n).format(format)
}
